<template>
  <q-badge
    v-if="small"
    rounded
    :color="invoiceStatusColour(invoice.status)"
    style="width: 10px;"
    class="chip text-center"
  />
  <q-chip
    v-else
    :color="invoiceStatusColour(invoice.status)"
    text-color="white"
    class="chip text-center"
    dense
    :square="flat"
    style="width: 85px;"
  >
    {{ invoiceStatusName(invoice.status) }}
  </q-chip>
</template>

<script>
import invoiceMixin from './mixin'

export default {
  mixins: [invoiceMixin],
  props: {
    invoice: {
      required: true,
      type: Object
    },
    flat: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.chip {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}
</style>
